
import { NavLink, useLocation  } from "react-router-dom";
import "./css/dashboard.css";
import { useState, useEffect } from "react";
import "./css/ModalPopup.css";
import "./css/header.css";
import ModalPopup from "./ModalPopup";


function Header() { 

const [open, setOpen] = useState(false);
const [openMe, setOpenMe] = useState(false);
const [openPupup, setOpenPopup] = useState(false);


 //const location = useLocation();

    const logout = () => {
        //alert("Logging out");
        sessionStorage.removeItem("token");
        window.location.href = "/";    
    };




    
    const userName = sessionStorage.getItem("userName"); // or session
    const apartment = sessionStorage.getItem("apartment"); // or session
    const firstTwoChars = userName.slice(0, 2)

   const userType = sessionStorage.getItem("userType"); // or session
   const isUserTypeAdmin = userType === "admin" ? true : false;
   const [menuOpen, setMenuOpen] = useState(false);
  // alert(userType + " TEST " + isUserTypeAdmin);
  

    return(<>
     <nav className="navbar">
      <div className="nav-logo">🏢 Society</div>
      {/* Hamburger */}
        <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>
      <ul className={`nav-links ${menuOpen ? "mobile-open" : ""}`}>
        <li>
          <NavLink to="/dashboard" className="nav-item"  onClick={() => setMenuOpen(false)}> 
            Dashboard
          </NavLink>
        </li>
        <li>
          <NavLink to="/residents" className="nav-item" onClick={() => setMenuOpen(false)}  >
            Residents
          </NavLink>
        </li>
        <li>
          <NavLink to="/notices" className="nav-item" onClick={() => setMenuOpen(false)}>
            Notices
          </NavLink>
        </li>
        <li>
          <NavLink to="/complaints" className="nav-item" onClick={() => setMenuOpen(false)}>
            Complaints
          </NavLink>
        </li>
         {isUserTypeAdmin && <li>
          <NavLink to="/users" className="nav-item" onClick={() => setMenuOpen(false)}>
            Users
          </NavLink>
        </li>}
        <li>
    <div className="nav-item common-area-menu" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <div className="nav-title" onClick={() => setOpen(!open)}>
        Common Areas <span className="arrow">▾</span>
      </div>

      {open && (
        <div className="dropdown">
          <NavLink to="/common-areas/overview">Overview</NavLink>
          <NavLink to="/common-areas/book">Book Area</NavLink>
          {!isUserTypeAdmin && <NavLink to="/common-areas/my-bookings">My Bookings</NavLink>}
          <NavLink to="/common-areas/history">History</NavLink>          
          { isUserTypeAdmin && <NavLink to="/common-areas/checkpendingbookings">Pending Bookings</NavLink>}
          { isUserTypeAdmin && <NavLink to="/Payment">Payment</NavLink>}
          { isUserTypeAdmin && <NavLink to="/Expenses/List">Expenses</NavLink>}

        </div>
      )}
      </div>
        </li>
      </ul>
     

    <div className={`nav-item user-menu ${menuOpen ? "mobile-user-menu" : ""}`} onMouseEnter={() => setOpenMe(true)} onMouseLeave={() => setOpenMe(false)}>
      <div className="nav-title"><button className="logout-btn" onClick={() => setOpenMe(!openMe)} >  {/*<!-- Old code on button click  onClick={logout} --> */}
        {firstTwoChars}
      </button> </div>

        {openMe && (
          <div className="dropdown user-dropdown">
             <NavLink onClick={() => setOpenPopup(true)}>Me</NavLink>
             <NavLink onClick={logout}>Logout</NavLink>
             {/*<a href="" onClick={logout}> Logout </a>*/}
          </div>

        )}

        {

      <ModalPopup
        isOpen={openPupup}
        title="My Details"
        onClose={() => setOpenPopup(false)}
      >
           <p>User Name: {userName}</p>
           <p>User Type: {userType}</p>
           <p>Apartment: {apartment}</p>
           <p>Email: N/A</p>

        <button onClick={() => setOpenPopup(false)}>Close</button>
      </ModalPopup>


        }
         





    </div>
    </nav>   
    </>);
}
export default Header;

